// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_container_checklist {
    width: 100%;
    height: 100%;
    padding: 25px 40px 25px 40px;
    background-color: white;
    border-radius: 10px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr 1fr;
}

.simple_label_checklist {
    font-size: 16px;
    font-weight: 600;
    color: #130F30;
    margin-bottom: 0px;
    width: -moz-fit-content;
    width: fit-content;
}

.sub_label_checklist {
    max-width: 500px;
    font-size: 12px;
    line-height: 17px;
    margin-bottom: 5px;
}

.simple_label_checklist > span {
    font-size: 12px;
    font-weight: 400;
    color: #130F30;
    margin-bottom: 0px;
    margin-left: 7px;
}

.header_btn_container {
    display: flex;
    align-items: center;
    gap: 30px;
}

@media (max-width: 1000px) {
    .main_container {
        grid-template-columns: 1fr;
    }

}

.main_container.full {
    grid-template-columns: 1fr;
    padding-top: 40px;
    padding-bottom: 40px;
}

.container_underline {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 90%;
    height: 1px;
    border-bottom: 1px dashed rgba(114, 112, 112, 0.5);
}

.form_container {
    max-height: 1000px;
    overflow-y: auto;
}

.calendar_container {
    max-width: 340px;
}

.container_underline.full {
    width: 100%;
}

.sub_radio {
    margin-top: 10px;
    margin-left: 30px;
    color: #727070;
}

textarea {
    margin-top: 10px;
    margin-left: 30px;
    max-width: 500px;
    min-height: 50px;
    padding-left: 10px;
    padding-top: 5px;
    width: 100%;
    border: none;
    background-color: #F0F0F0;
}

.main_form_right {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 30px;
    background-color: #E5E5E5;
}

@media (max-width: 1000px) {
    .main_form_right {
        display: none;
    }
}

.example_header {
    width: 100%;
    height: 25px;
    background-color: #130F30;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.dot {
    width: 10px;
    height: 10px;
    min-width: 10px;
    min-height: 10px;
    border-radius: 50%;
    margin-left: 8px;
}

.example_header > p {
    margin-right: 10px;
    font-size: 14px;
}

.example_body {
    width: 100%;
    background-color: white;
    padding: 30px;
    box-sizing: border-box;
}

.top_section {
    display: grid;
    grid-template-columns: 40% 60%;
    grid-gap: 20px;
    position: relative;
}

.example_title_container > h4 {
    font-size: 12px;
}

.mw_button {
    width: 100%;
    max-width: 128px;
    background-color: #FF5242;
    font-size: 10px;
    padding: 7px;
    color: white;
    text-transform: uppercase;
}

.mw_button.icon {
    width: 100%;
    max-width: 128px;
    background-color: #FF5242;
    font-size: 10px;
    padding: 7px;
    color: white;
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.mw_button.icon > img{
    height: 15px;
}

.example_text {
    font-size: 11px;
    line-height: 20px;
}

.example_footer {
    width: 100%;
    height: 60px;
    background-color: #130F30;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 10px;
    box-sizing: border-box;
}

.example_footer_skeleton {
    height: 12px;
    background-color: rgba(39, 32, 62, 1);
    margin-bottom: 7px;
}

.hint_container_checklist {
    position: absolute;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.hint_dot {
    width: 13px;
    height: 13px;
    min-width: 13px;
    min-height: 13px;
    border-radius: 50%;
    margin-left: 10px;
}

.hint_container_checklist.image {
    left: -150px;
    top: 0;
}

.tooltip_checklist {
    position: relative;
    display: inline-block;
}

/* Tooltip text */
.tooltip_checklist .tooltiptext {
    background-color: #F5F4F0;
    color: black;
    text-align: center;
    padding: 5px;
    border-radius: 6px;
    font-size: 10px;
}

.tooltip_checklist .tooltiptext::after {
    content: " ";
    position: absolute;
    top: 50%;
    left: 100%; /* To the right of the tooltip */
    margin-top: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent transparent #F5F4F0;
}

.example_logo_container {
    margin-top: 10px;
    position: relative;
}

.hint_container_checklist.logo {
    left: -70px;
    top: 25%;
}

.buttons_container {
    position: relative;
}

.hint_container_checklist.btn {
    left: -130px;
    top: 25%;
}

.hint_container_checklist.title {
    left: -110px;
    top: 10%;
}

.hint_container_checklist.merchant {
    left: -110px;
    top: 0;
}

.hint_container_checklist.conditions {
    left: -110px;
    top: 0;
}

.hint_container_checklist.additionalConditions {
    left: -170px;
    top: 0;
}

.hint_container_checklist.description {
    left: -150px;
    top: 0;
}

.hint_container_checklist.highlights {
    left: -110px;
    top: 0;
}

.hint_container_checklist.links {
    left: -80px;
    top: 0;
}

.hint_container_checklist.text {
    left: -100px;
    top: 0;
}

.hint_container_checklist.images {
    left: -160px;
    top: 0;
}

.example_title_container {
    position: relative;
}

.example_title_container.outlined {
    background-color: rgba(255, 175, 66, 0.5);
}

.example_title_container.outlined.merchant {
    background-color: rgba(237, 144, 201, 0.5);
}

.example_title_container.outlined.conditions {
    background-color: rgba(119, 224, 204, 0.5);
}

.example_title_container.outlined.additionalConditions {
    background-color: rgba(149, 136, 255, 0.5);
}

.example_title_container.outlined.description {
    background-color: rgba(157, 214, 99, 0.5);
}

.example_title_container.outlined.highlights {
    background-color: rgba(149, 136, 255, 0.5);
}

.example_title_container.outlined.text {
    background-color: rgba(237, 144, 201, 0.5);
}

.example_title_container.outlined.images {
    background-color: rgba(41, 134, 147, 0.5);
}

.example_title_container.outlined.links {
    background-color: rgba(149, 136, 255, 0.5);
}

.example_textarea_title {
    font-size: 9px;
}

.example_textarea {
    width: 90%;
    height: 60px;
    background-color: #E5E5E5;
    color: white;
}

.example_textarea > p {
    font-size: 9px;
    margin-left: 5px;
    margin-top: 5px;
}

.image_btn {
    font-family: Montserrat;
    font-weight: 600;
    color: rgba(19, 15,48,0.75);
    width: inherit;
    font-size: 12px;
    position: absolute;
    top: 0;
    right: 10%;
    height: 30px;
    border: 1px solid rgba(19, 15,48,0.45);
    border-radius: 3px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 5px;
    padding-right: 5px;
    min-width: 150px;
}

@media (max-width:890px){
    .image_btn {
        font-family: Montserrat;
        font-weight: 600;
        color: rgba(19, 15,48,0.75);
        width: inherit;
        font-size: 12px;
        position: initial;
        top: 0;
        right: 10%;
        height: 30px;
        border: 1px solid rgba(19, 15,48,0.45);
        border-radius: 3px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 5px;
        padding-right: 5px;
    }
}

.image_btn > img {
    width: 15px;
    margin-right: 3px;
}

.main_form_header_text {
    font-size: 12px;
}

.text_form_textarea {
    margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Widgets/Checklist/index.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI;QACI,0BAA0B;IAC9B;;AAEJ;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,kCAAkC;IAClC,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,UAAU,EAAE,gCAAgC;IAC5C,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,yDAAyD;AAC7D;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,MAAM;AACV;;AAEA;IACI,YAAY;IACZ,MAAM;AACV;;AAEA;IACI,YAAY;IACZ,MAAM;AACV;;AAEA;IACI,YAAY;IACZ,MAAM;AACV;;AAEA;IACI,YAAY;IACZ,MAAM;AACV;;AAEA;IACI,WAAW;IACX,MAAM;AACV;;AAEA;IACI,YAAY;IACZ,MAAM;AACV;;AAEA;IACI,YAAY;IACZ,MAAM;AACV;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,YAAY;IACZ,sCAAsC;IACtC,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI;QACI,uBAAuB;QACvB,gBAAgB;QAChB,2BAA2B;QAC3B,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,MAAM;QACN,UAAU;QACV,YAAY;QACZ,sCAAsC;QACtC,kBAAkB;QAClB,sBAAsB;QACtB,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;AACb","sourcesContent":[".main_container_checklist {\n    width: 100%;\n    height: 100%;\n    padding: 25px 40px 25px 40px;\n    background-color: white;\n    border-radius: 10px;\n    box-sizing: border-box;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n}\n\n.simple_label_checklist {\n    font-size: 16px;\n    font-weight: 600;\n    color: #130F30;\n    margin-bottom: 0px;\n    width: fit-content;\n}\n\n.sub_label_checklist {\n    max-width: 500px;\n    font-size: 12px;\n    line-height: 17px;\n    margin-bottom: 5px;\n}\n\n.simple_label_checklist > span {\n    font-size: 12px;\n    font-weight: 400;\n    color: #130F30;\n    margin-bottom: 0px;\n    margin-left: 7px;\n}\n\n.header_btn_container {\n    display: flex;\n    align-items: center;\n    gap: 30px;\n}\n\n@media (max-width: 1000px) {\n    .main_container {\n        grid-template-columns: 1fr;\n    }\n\n}\n\n.main_container.full {\n    grid-template-columns: 1fr;\n    padding-top: 40px;\n    padding-bottom: 40px;\n}\n\n.container_underline {\n    margin-top: 20px;\n    margin-bottom: 20px;\n    width: 90%;\n    height: 1px;\n    border-bottom: 1px dashed rgba(114, 112, 112, 0.5);\n}\n\n.form_container {\n    max-height: 1000px;\n    overflow-y: auto;\n}\n\n.calendar_container {\n    max-width: 340px;\n}\n\n.container_underline.full {\n    width: 100%;\n}\n\n.sub_radio {\n    margin-top: 10px;\n    margin-left: 30px;\n    color: #727070;\n}\n\ntextarea {\n    margin-top: 10px;\n    margin-left: 30px;\n    max-width: 500px;\n    min-height: 50px;\n    padding-left: 10px;\n    padding-top: 5px;\n    width: 100%;\n    border: none;\n    background-color: #F0F0F0;\n}\n\n.main_form_right {\n    box-sizing: border-box;\n    width: 100%;\n    height: 100%;\n    padding: 30px;\n    background-color: #E5E5E5;\n}\n\n@media (max-width: 1000px) {\n    .main_form_right {\n        display: none;\n    }\n}\n\n.example_header {\n    width: 100%;\n    height: 25px;\n    background-color: #130F30;\n    color: white;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.dot {\n    width: 10px;\n    height: 10px;\n    min-width: 10px;\n    min-height: 10px;\n    border-radius: 50%;\n    margin-left: 8px;\n}\n\n.example_header > p {\n    margin-right: 10px;\n    font-size: 14px;\n}\n\n.example_body {\n    width: 100%;\n    background-color: white;\n    padding: 30px;\n    box-sizing: border-box;\n}\n\n.top_section {\n    display: grid;\n    grid-template-columns: 40% 60%;\n    grid-gap: 20px;\n    position: relative;\n}\n\n.example_title_container > h4 {\n    font-size: 12px;\n}\n\n.mw_button {\n    width: 100%;\n    max-width: 128px;\n    background-color: #FF5242;\n    font-size: 10px;\n    padding: 7px;\n    color: white;\n    text-transform: uppercase;\n}\n\n.mw_button.icon {\n    width: 100%;\n    max-width: 128px;\n    background-color: #FF5242;\n    font-size: 10px;\n    padding: 7px;\n    color: white;\n    text-transform: uppercase;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.mw_button.icon > img{\n    height: 15px;\n}\n\n.example_text {\n    font-size: 11px;\n    line-height: 20px;\n}\n\n.example_footer {\n    width: 100%;\n    height: 60px;\n    background-color: #130F30;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    padding-top: 15px;\n    padding-bottom: 15px;\n    padding-left: 10px;\n    box-sizing: border-box;\n}\n\n.example_footer_skeleton {\n    height: 12px;\n    background-color: rgba(39, 32, 62, 1);\n    margin-bottom: 7px;\n}\n\n.hint_container_checklist {\n    position: absolute;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.hint_dot {\n    width: 13px;\n    height: 13px;\n    min-width: 13px;\n    min-height: 13px;\n    border-radius: 50%;\n    margin-left: 10px;\n}\n\n.hint_container_checklist.image {\n    left: -150px;\n    top: 0;\n}\n\n.tooltip_checklist {\n    position: relative;\n    display: inline-block;\n}\n\n/* Tooltip text */\n.tooltip_checklist .tooltiptext {\n    background-color: #F5F4F0;\n    color: black;\n    text-align: center;\n    padding: 5px;\n    border-radius: 6px;\n    font-size: 10px;\n}\n\n.tooltip_checklist .tooltiptext::after {\n    content: \" \";\n    position: absolute;\n    top: 50%;\n    left: 100%; /* To the right of the tooltip */\n    margin-top: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: transparent transparent transparent #F5F4F0;\n}\n\n.example_logo_container {\n    margin-top: 10px;\n    position: relative;\n}\n\n.hint_container_checklist.logo {\n    left: -70px;\n    top: 25%;\n}\n\n.buttons_container {\n    position: relative;\n}\n\n.hint_container_checklist.btn {\n    left: -130px;\n    top: 25%;\n}\n\n.hint_container_checklist.title {\n    left: -110px;\n    top: 10%;\n}\n\n.hint_container_checklist.merchant {\n    left: -110px;\n    top: 0;\n}\n\n.hint_container_checklist.conditions {\n    left: -110px;\n    top: 0;\n}\n\n.hint_container_checklist.additionalConditions {\n    left: -170px;\n    top: 0;\n}\n\n.hint_container_checklist.description {\n    left: -150px;\n    top: 0;\n}\n\n.hint_container_checklist.highlights {\n    left: -110px;\n    top: 0;\n}\n\n.hint_container_checklist.links {\n    left: -80px;\n    top: 0;\n}\n\n.hint_container_checklist.text {\n    left: -100px;\n    top: 0;\n}\n\n.hint_container_checklist.images {\n    left: -160px;\n    top: 0;\n}\n\n.example_title_container {\n    position: relative;\n}\n\n.example_title_container.outlined {\n    background-color: rgba(255, 175, 66, 0.5);\n}\n\n.example_title_container.outlined.merchant {\n    background-color: rgba(237, 144, 201, 0.5);\n}\n\n.example_title_container.outlined.conditions {\n    background-color: rgba(119, 224, 204, 0.5);\n}\n\n.example_title_container.outlined.additionalConditions {\n    background-color: rgba(149, 136, 255, 0.5);\n}\n\n.example_title_container.outlined.description {\n    background-color: rgba(157, 214, 99, 0.5);\n}\n\n.example_title_container.outlined.highlights {\n    background-color: rgba(149, 136, 255, 0.5);\n}\n\n.example_title_container.outlined.text {\n    background-color: rgba(237, 144, 201, 0.5);\n}\n\n.example_title_container.outlined.images {\n    background-color: rgba(41, 134, 147, 0.5);\n}\n\n.example_title_container.outlined.links {\n    background-color: rgba(149, 136, 255, 0.5);\n}\n\n.example_textarea_title {\n    font-size: 9px;\n}\n\n.example_textarea {\n    width: 90%;\n    height: 60px;\n    background-color: #E5E5E5;\n    color: white;\n}\n\n.example_textarea > p {\n    font-size: 9px;\n    margin-left: 5px;\n    margin-top: 5px;\n}\n\n.image_btn {\n    font-family: Montserrat;\n    font-weight: 600;\n    color: rgba(19, 15,48,0.75);\n    width: inherit;\n    font-size: 12px;\n    position: absolute;\n    top: 0;\n    right: 10%;\n    height: 30px;\n    border: 1px solid rgba(19, 15,48,0.45);\n    border-radius: 3px;\n    box-sizing: border-box;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-left: 5px;\n    padding-right: 5px;\n    min-width: 150px;\n}\n\n@media (max-width:890px){\n    .image_btn {\n        font-family: Montserrat;\n        font-weight: 600;\n        color: rgba(19, 15,48,0.75);\n        width: inherit;\n        font-size: 12px;\n        position: initial;\n        top: 0;\n        right: 10%;\n        height: 30px;\n        border: 1px solid rgba(19, 15,48,0.45);\n        border-radius: 3px;\n        box-sizing: border-box;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding-left: 5px;\n        padding-right: 5px;\n    }\n}\n\n.image_btn > img {\n    width: 15px;\n    margin-right: 3px;\n}\n\n.main_form_header_text {\n    font-size: 12px;\n}\n\n.text_form_textarea {\n    margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
